// muteState.js — singleton shared between NotificationDrawer and NotificationComponent
let _muted = true;
const _listeners = new Set();

const muteState = {
    get() { return _muted; },
    set(val) { _muted = val; _listeners.forEach(fn => fn(val)); },
    toggle() { muteState.set(!_muted); },
    subscribe(fn) { _listeners.add(fn); return () => _listeners.delete(fn); },
};

export default muteState;